import { FC } from 'react'
import { Text, TextProps, VStack } from '@chakra-ui/react'
import { AddressDTO } from '@/lib/address/types'

export const AddressDisplay: FC<{ address: AddressDTO; showTitle?: boolean } & TextProps> = ({
  address,
  showTitle = true,
  ...props
}) => {
  if (!address || !address.formatted) return null

  return (
    <VStack align="flex-start" spacing={1}>
      {showTitle && (
        <Text fontSize="sm" color="gray.500" fontWeight="medium">
          Dirección
        </Text>
      )}
      <Text fontSize="md" lineHeight="1.4" {...props}>
        {address.formatted}
      </Text>
    </VStack>
  )
}
